import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 = "https://cdn.msu.edu.in/msu_emergency_medical_tech1_f3261b53d1.webp";
const OJLImg2 = "https://cdn.msu.edu.in/msu_emergency_medical_tech3_596a3c4319.webp";
const OJLImg3 = "https://cdn.msu.edu.in/msu_emergency_medical_tech4_509a1d5471.webp";
const OJLImg4 = "https://cdn.msu.edu.in/msu_emergency_medical_tech2_d2775e1654.webp";
const OJLImg5 = "https://cdn.msu.edu.in/msu_emergency_medical_tech6_b923c3ee90.webp";
const OJLImg6 = "https://cdn.msu.edu.in/msu_emergency_medical_tech5_16b83ba5e8.webp";

const Img1 = "https://cdn.msu.edu.in/Radiology_1_fd63892112.webp";
const Img2 = "https://cdn.msu.edu.in/dialysis_3_802e00fc5b.jpg";
const Img3 = "https://cdn.msu.edu.in/R_4_20cfa25db5.webp";
const Img4 = "https://cdn.msu.edu.in/R_3_bb8d3983be.webp";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const bdttData = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Bachelors of Dialysis Therapy Technology", url: "" }
        ],
        // Image from MSU Offering section
        bannerImg: '/assets/industry-co-led-banner.png',
        title: "Bachelors of Dialysis Therapy Technology",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: EMVERSITY
        },
        duration: "4 Year Undergraduate Degree Programme",
        description:
            "Learn about haemodialysis and peritoneal dialysis, renal patient monitoring, vascular access management, fluid and electrolyte balance, dialysis equipment and water treatment systems, and more in the healthcare sector.",

        stats: [
            {
                value: "Up to 70%",
                label: "Hands-on training"
            },
            {
                value: "12 Months",
                label: "Paid on-the-job learning"
            },
            {
                value: "100%",
                label: "Placement assistance"
            }
        ],

        buttons: {
            download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: 'https://img.youtube.com/vi/wMCs06gZzyA/hqdefault.jpg',
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/wMCs06gZzyA"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",
        title: "A Degree Built for Critical Renal Care",
        description: [
            "The Bachelors of Dialysis Therapy Technology prepares students to manage patients with kidney disorders through specialised dialysis procedures and continuous clinical care. The program combines strong biomedical foundations with hands-on training in haemodialysis, peritoneal dialysis and renal patient management.",
            "Through simulation-based learning, clinical training, and structured hospital internships, students develop the technical expertise and on-ground confidence required in nephrology units and dialysis centres. Graduates are equipped to deliver precise, safe and life-sustaining care for patients with chronic kidney conditions."
        ],
        stats: [
            { value: "Up to 70%", label: "Hands-on training" },
            { value: "12 Months", label: "Paid on-the-job learning" },
            { value: "100%", label: "Placement assistance" }
        ],
        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Scholarships Available"
        ],
        journeyTitle: "Your 4-Year Journey",
        journey: [
            {
                "phase": "YEAR 1",
                "title": "Biomedical Foundations",
                "description": "Human anatomy with renal focus, physiology, biochemistry, and basics of patient care"
            },
            {
                "phase": "YEAR 2",
                "title": "Core Dialysis Sciences",
                "description": "Renal pathology, dialysis technology, vascular access, and patient monitoring"
            },
            {
                "phase": "YEAR 3",
                "title": "Advanced Dialysis & Renal Care",
                "description": "Critical care dialysis, paediatric dialysis, transplant support, and clinical rotations"
            },
            {
                "phase": "YEAR 4",
                "title": "Clinical Practice & Professional Readiness",
                "description": "Dialysis unit operations, advanced patient care, internships, and research project"
            },
            {
                "phase": "GRADUATE",
                "title": "Bachelors of Dialysis Therapy Technology",
                "description": "Industry-ready dialysis and renal care professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",
        title: {
            first: "Comprehensive",
            highlight: "Dialysis & Renal Care Education"
        },
        description:
            "We offer a UGC-recognised, full-time undergraduate degree, Bachelors of Dialysis Therapy Technology at Medhavi Skills University, Sikkim. It is an industry-aligned allied healthcare program designed to build strong clinical and technical skills, preparing students for specialised roles in dialysis and renal care.",
        learningBox: {
            title: "Key Areas of Learning",
            points: [
                "Human Anatomy",
                "General Pharmacology",
                "Biomedical Waste Management",
                "Renal Nutrition",
                "Renal Transplantation and Coordination",
                "Basic and Advanced Cardiac Life Support"
            ]
        },
        image: 'https://cdn.msu.edu.in/R_5_21755354c6.webp'
    },

    whyEMT: {
        tag: "WHY DIALYSIS THERAPY TECHNOLOGY. WHY NOW.",
        title: "The Lifeline of India's Renal Care Infrastructure",
        description:
            "Our curriculum addresses the staggering rise in kidney ailments across the country. As the 'Diabetes Capital of the World' India's surge in renal failure has made the Dialysis Therapist one of the most critical specialists in the modern clinical workforce.",
        stats: [
            {
                value: "$1.36 Billion",
                text: "Valuation of the Indian Dialysis Market. With the sector expanding rapidly, there is an urgent need for technologists to operate the advanced, AI-enabled hemodialysis systems now becoming the standard in super-specialty hospitals.",
            },
            {
                value: "220,000+",
                text: "New Renal Disease patients are added annually. This influx creates a demand for over 34 million dialysis sessions every year. The industry requires a massive workforce of certified therapists to staff the growing network of private and public units.",
            },
            {
                value: "1,700+",
                text: "Centers under the National Dialysis Programme. The government's mandate to provide free dialysis in every district has pushed demand beyond metros. This national mission has created a secure, high-growth career path in both Hemo and Peritoneal dialysis.",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Emversity, Delivered at MSU Campus",
        description:
            "Where academic excellence meets the operational demands of the modern allied and healthcare industry.",
        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning.",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships.",
            },
            {
                number: "03",
                text: "Well-equipped simulation labs, advanced training setups and hands-on field training.",
            },
        ],
        pointerTitle: "Highlights from The Programme:",
        highlights: [
            "Programme aligned with NEP2020, focused in Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-job Learning",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Chance to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives"
        ],
        // Advantage/Campus Image
        image: 'https://cdn.msu.edu.in/advantages_e4b02487af.webp',
    },

    CTA: {
        title: "Start Your Journey in Renal Care with Emversity's",
        highlights: "Bachelors of Dialysis Therapy Technology",
        url: "#",
        btnName: "Apply Now"
    },

    onJobtrainningData: {
        tag: "ON-THE-JOB LEARNING",
        title: "Practical Industry Exposure",
        description: "Our On-the-job Learning (OJL) enables students to gain real industry experience and earn a stipend while you gain your degree.",
        images: [
            { "id": 1, "src": OJLImg1, "alt": "Medical training" },
            { "id": 2, "src": OJLImg2, "alt": "Lab practice" },
            { "id": 3, "src": OJLImg3, "alt": "Patient training" },
            { "id": 4, "src": OJLImg4, "alt": "Lab testing" },
            { "id": 5, "src": OJLImg5, "alt": "Computer lab work" },
            { "id": 6, "src": OJLImg6, "alt": "Chemical lab testing" }
        ]
    },

    addtionSkill: {
        "courseSections": {
            "AdditionalSkills": {
                "tag": "BONUS CREDENTIALS",
                "title": "Additional Skill Development",
                "description": "Students will have the opportunity to build specialised skills that set them apart in the competitive healthcare market. These credentials, earned alongside your degree, strengthen technical expertise, enhance professional credibility and prepare you for roles with leading national and international healthcare providers.",
                "image": {
                    "url": 'https://cdn.msu.edu.in/small_RAH_6083_9150e01c9b.jpg',
                    "alternativeText": "Skill Certification"
                },
                "items": [
                    { "id": 1, "text": "Cambridge English for Healthcare Professionals as per CEFR Standards", "icon": Icon1 },
                    { "id": 2, "text": "Dialysis Equipment Handling & Infection Control Practices", "icon": Icon2 },
                    { "id": 3, "text": "Nationally & Globally Recognised", "icon": Icon1 }
                ],
                "button": { "text": "Apply Now", "link": "/apply" }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description: "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities.",
        images: [
            { id: 1, src: Img1, size: "large", alt: "Dialysis Units" },
            { id: 2, src: Img2, size: "large", alt: "Emergency Units" },
            { id: 3, src: Img3, size: "small", alt: "Medical Prep Stations" },
            { id: 4, src: Img4, size: "small", alt: "Renal Care Lab" },
            { id: 5, src: Img5, size: "small", alt: "Simulation Lab" },
        ],
    },

    studentStoriesData: {
        title: "Medhavian Speak",
        subText: "Real journeys of action and achievement.",
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Who Can Apply?",
        description: "10+2 (Any Stream) with 50% Aggregate with Physics, Chemistry and Biology/Mathematics as principal subjects.",
        button: { text: 'Apply Now', url: "" },
        items: [
            {
                title: "12th Pass - Any Stream",
                text: "Candidates from any stream with Physics, Chemistry and Biology/Mathematics as principal subjects are eligible to apply for the programme.",
            },
        ],
    },

    careerProspects: {
        "tag": "CAREER PROSPECTS",
        "heading": "Career Prospects",
        "description": "The Bachelors of Dialysis Therapy Technology opens doors to specialised, high-demand roles across hospitals, dialysis centres and renal care networks.",
        "roles": [
            "Dialysis Technologist",
            "Haemodialysis Technician",
            "Peritoneal Dialysis Specialist",
            "Renal Care Technologist",
            "Dialysis Unit Supervisor",
            "Home Dialysis Care Coordinator",
            "Nephrology Assistant Technician",
            "Renal Care Operations Executive"
        ]
    },

    curriculumStructure: {
        "label": "What You Will Learn",
        "heading": "Curriculum Structure",
        "description": "The curriculum combines strong biomedical foundations with intensive applied training and industry-integrated modules, ensuring students develop real-world readiness for emergency care environments.",
        "semesters": [
            {
                "name": "Semester 1",
                "title": "Building Foundations in Human Sciences and Dialysis Care",
                "description": "The first semester lays the groundwork for a career in dialysis therapy by introducing students to the fundamental sciences that support patient care and renal health management. Learners develop a strong understanding of human anatomy, physiology, and biochemistry while gaining familiarity with medical terminology, healthcare documentation, and professional ethics. The curriculum also provides an introduction to dialysis therapy and clinical environments, helping students build the scientific knowledge, professional values, and practical awareness required for advanced learning and patient-focused care.",
                "subjects": [
                    { "name": "Medical Terminology and Record Keeping (Including Anatomical Terms)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Professionalism and Values & Indian Constitution", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Human Anatomy", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Human Physiology", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Biochemistry", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Introduction to Dialysis Therapy", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Human Anatomy (Practicals)", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" },
                    { "name": "Human Physiology (Practicals)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Biochemistry (Practicals)", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Community Orientation and Clinical Visit", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ]
            },
            {
                "name": "Semester 2",
                "title": "Developing Core Competencies in Renal Care and Dialysis Procedures",
                "description": "The second semester builds upon foundational medical sciences by introducing students to the clinical concepts and procedures central to dialysis therapy. Learners gain an understanding of disease processes, microorganisms, pharmacological principles, and the anatomical and physiological aspects relevant to renal care. The curriculum also focuses on the fundamentals of dialysis therapy through both theoretical and practical learning, enabling students to develop the technical knowledge and clinical skills required to support safe, effective, and patient-centred dialysis treatment.",
                "subjects": [
                    { "name": "Pathology", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Microbiology", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "General Pharmacology", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Applied Anatomy & Physiology Related to Dialysis Therapy", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Fundamentals of Dialysis Therapy", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Pathology (Practicals)", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Microbiology (Practicals)", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" },
                    { "name": "Applied Anatomy & Physiology Related to Dialysis Therapy (Practicals)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Fundamentals of Dialysis Therapy (Practicals)", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Clinical Postings I", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ]
            },
            {
                "name": "Semester 3",
                "title": "Strengthening Clinical Understanding of Renal Disorders and Patient Care",
                "description": "The third semester focuses on the clinical, ethical, and operational aspects of dialysis therapy, enabling students to develop a comprehensive understanding of patient care in renal healthcare settings. Learners explore kidney disease pathophysiology, dialysis-specific instrumentation, biomedical waste management, and nursing care principles that support safe and effective treatment delivery. The curriculum also introduces sociological perspectives in healthcare, medical ethics, and legal responsibilities, helping students strengthen their professional competence while gaining deeper exposure to real-world clinical practice.",
                "subjects": [
                    { "name": "Sociology in Health Care", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Biomedical Waste Management", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Pathophysiology of Kidney Diseases", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Elective Course (To Be Chosen by the Student)", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Instrumentation Specific to Dialysis Therapy", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Basic Principles of Nursing Care", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Medical Law and Ethics", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" },
                    { "name": "Instrumentation Specific to Dialysis Therapy (Practicals)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Clinical Postings II", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" }
                ]
            },
            {
                "name": "Semester 4",
                "title": "Advancing Dialysis Techniques and Patient Management Skills",
                "description": "The fourth semester deepens students' understanding of dialysis treatment, patient care, and clinical decision-making in renal healthcare settings. Learners explore pharmacological considerations, renal nutrition, dialysis procedures, and medical electronics that support the delivery of safe and effective dialysis services. The curriculum also introduces research methodology, biostatistics, and psychological aspects of patient care, enabling students to develop analytical thinking, technical proficiency, and a patient-centred approach. Through practical training and clinical postings, students strengthen their readiness for advanced clinical responsibilities in dialysis therapy.",
                "subjects": [
                    { "name": "Pharmacology Related to Dialysis Therapy", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Psychology", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Renal Nutrition", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Dialysis Therapies – Part I", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Medical Electronics for Health Sciences", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Research Methodology and Biostatistics", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Pharmacology Related to Dialysis Therapy (Practicals)", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" },
                    { "name": "Dialysis Therapies – Part I (Practicals)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Clinical Postings III", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" }
                ]
            },
            {
                "name": "Semester 5",
                "title": "Mastering Advanced Dialysis and Renal Care Interventions",
                "description": "The fifth semester focuses on advanced dialysis practices, renal transplantation, and specialized extracorporeal therapies used in the management of complex kidney disorders. Students develop a deeper understanding of clinical challenges encountered in dialysis settings while learning to apply evidence-based approaches to patient care and treatment planning. The curriculum also emphasizes transplant coordination, advanced therapeutic procedures, and hands-on clinical training, enabling learners to strengthen their technical expertise, critical thinking abilities, and preparedness for specialized roles in renal healthcare.",
                "subjects": [
                    { "name": "Dialysis Therapies – Part II", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Renal Transplantation and Coordination", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Clinical Problems and Evidence-Based Practice in Dialysis Therapy", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Advanced Extracorporeal Therapies", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Elective Course (To Be Chosen by the Student)", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Renal Transplantation and Coordination (Practicals)", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Advanced Extracorporeal Therapies (Practicals)", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" },
                    { "name": "Dialysis Therapies – Part II (Practicals)", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Clinical Postings IV", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" }
                ]
            },
            {
                "name": "Semester 6",
                "title": "Advancing Innovation, Quality and Critical Care in Renal Therapy",
                "description": "The sixth semester focuses on emerging developments in renal replacement therapies, quality assurance practices, and patient safety standards within dialysis care. Students gain insights into contemporary advancements in renal healthcare while developing an understanding of management principles that support efficient clinical operations. The curriculum also emphasizes life-saving interventions through basic and advanced cardiac life support training, enabling learners to respond effectively to critical situations. Through practical learning and continued clinical exposure, students strengthen their clinical competence, leadership abilities, and readiness for evolving roles in renal care services.",
                "subjects": [
                    { "name": "Recent Advancements in Renal Replacement Therapies", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Principles of Management", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "Introduction to Quality Assurance in Dialysis and Patient Safety", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Basic and Advanced Cardiac Life Support", "bgColor": "bg-[#E8D5FF]", "textColor": "text-[#6B00CC]" },
                    { "name": "Elective Course (To Be Chosen by the Student)", "bgColor": "bg-[#FFD5D5]", "textColor": "text-[#CC0000]" },
                    { "name": "Recent Advancements in Renal Replacement Therapies (Practicals)", "bgColor": "bg-[#D5F0FF]", "textColor": "text-[#006699]" },
                    { "name": "Basic and Advanced Cardiac Life Support (Practicals)", "bgColor": "bg-[#FFF3CC]", "textColor": "text-[#996600]" },
                    { "name": "Clinical Postings V", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ]
            },
            {
                "name": "Semester 7",
                "title": "Enhancing Clinical Proficiency Through Advanced Patient Care Exposure",
                "description": "The seventh semester is dedicated to intensive clinical training, enabling students to gain deeper exposure to dialysis procedures, patient management, and multidisciplinary healthcare environments. Through structured clinical postings, learners apply their theoretical knowledge and technical skills in real-world settings while refining their clinical judgment, communication abilities, and professional conduct. This hands-on experience strengthens confidence, reinforces best practices in patient care, and prepares students for the responsibilities of professional dialysis therapy practice.",
                "subjects": [
                    { "name": "Clinical Postings VI", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" }
                ]
            },
            {
                "name": "Semester 8",
                "title": "Transitioning to Professional Renal Care Practice",
                "description": "The final semester provides students with extensive hands-on experience through a compulsory rotatory internship and research-based learning. Working across diverse clinical settings, learners gain practical exposure to dialysis procedures, patient care protocols, interdisciplinary collaboration, and healthcare operations. The dissertation or project component encourages the application of research principles to real-world challenges in renal healthcare, fostering critical thinking, problem-solving, and evidence-based practice. Together, these experiences help students consolidate their learning and prepare for professional roles in dialysis therapy and renal care services.",
                "subjects": [
                    { "name": "Compulsory Rotatory Internship", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "Dissertation / Project", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" }
                ]
            },
            {
                name: "Value Addition",
                title: "Value-Added Learning Opportunities",
                description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                "keySubjectsLabel": "Key Features",
                subjects: [
                    { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]
    },

    faq: {
        id: 101,
        title: "Bachelors of Dialysis Therapy Technology",
        FAQ: [
            {
                "id": 1,
                "Question": "What is the university's role and what is Emversity's role?",
                "Answer": "MSU manages all academic matters — admissions, examinations, marksheets, transcripts, and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance, and the Cambridge English program. Emversity does not collect fees, conduct exams, or award degrees."
            },
            {
                "id": 2,
                "Question": "Is placement or internship stipend guaranteed?",
                "Answer": "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution."
            },
            {
                "id": 3,
                "Question": "Is this program recognised, and is it full-time?",
                "Answer": "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university."
            },
            {
                "id": 4,
                "Question": "How do I apply?",
                "Answer": "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details, and application deadlines, please contact the MSU admissions office directly."
            },
            {
                "id": 5,
                "Question": "What is the Head Start Programme?",
                "Answer": "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing, and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships."
            },
            {
                "id": 6,
                "Question": "Is this programme NCAHP aligned?",
                "Answer": "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus."
            }
        ]
    },
    coursePrice: { price: "₹8,00,000" }
};